import BaseComponent from '../BaseComponent';
import { ClassNames } from '../../utils/dom/css-classes';
import SelectorEngine from '../../utils/dom/selector-engine';

const NAME = 'BackButton';

export default class BackButton extends BaseComponent {
	static get NAME() {
		return NAME;
	}

	constructor(element, config) {
		super(element);
		if (this._element) {
			this.classPrefix = config.classPrefix;
		}
	}

	markup() {
		return `
			<div class="u-flex u-align-center" style="flex-direction:row">
				<button class="${this.classPrefix}__form-back-button lta-navigational-btn" aria-label="Go back">
					<svg class="lta-icon js-lta-text-input--btn-icon" width="1.5em" height="1.5em" fill="" alt="caret-left-fill" aria-hidden="true">
						<use xlink:href="/static/images/icons/lta-icons.svg#caret-left-fill"></use>
					</svg>
					<span class="u-fw-bold u-body2 text-decoration-underline">
						Back
					</span>
				</button>		  		
		  	</div>
		`;
	}

	show() {
		const backButton = SelectorEngine.findOne(`.${this.classPrefix}__form-back-button`, this._element);
		backButton?.classList?.remove(ClassNames.Hidden);
	}

	hide() {
		const backButton = SelectorEngine.findOne(`.${this.classPrefix}__form-back-button`, this._element);
		backButton?.classList?.add(ClassNames.Hidden);
	}
}
